import BigNumber from 'bignumber.js'
import { Token2BNumber } from 'interfaces/index.interface'
import { accountStore } from 'stores'
import { baseLcdService } from './base/baseLcdService'
import { cw20Service } from './cw20Service'

class TerraService {
  fetchBalance = async () => {
    const fetchNative = async () => {
      if (!accountStore.address) return
      const { lcdClient } = baseLcdService
      const [coins] = await lcdClient.bank.balance(accountStore.address)
      let coinBalance: Token2BNumber = {}
      coins.toArray().forEach((coin) => {
        coinBalance[coin.denom] = new BigNumber(coin.amount.toNumber()).div(
          `1e6`,
        )
        if (coin.denom === 'uusd') {
          const nb = coinBalance[coin.denom].minus(1.5)
          coinBalance[coin.denom] = nb.lte(0) ? coinBalance[coin.denom] : nb
        }
      })
      accountStore.updateBalance(coinBalance)
    }

    const fetchCW20 = async () => {
      if (accountStore.tokens.length > 0) {
        const { tokens } = accountStore
        const res = await Promise.all(
          tokens
            .filter((token) => token.includes('terra'))
            .map(async (token) => {
              return {
                token,
                bal: await cw20Service.getBalance(token, accountStore.address),
              }
            }),
        )
        let tokenBalance: Token2BNumber = {}
        res.forEach(({ token, bal }) => {
          tokenBalance[token] = bal
        })
        accountStore.updateBalance(tokenBalance)
      }
    }

    await Promise.all([fetchCW20(), fetchNative()])
  }
}

export const terraService = new TerraService()
